module.exports = __webpack_public_path__ + "img/bg-vhub-login.dbcf7634.jpg";